import React, { FC, ReactNode } from 'react';
import cx from 'classnames';

export type TColumnVariant = 'two' | 'four';

const columnVariant: Record<TColumnVariant, string> = {
  two: '@3xl:grid-cols-2',
  four: '@3xl:grid-cols-2 @4xl:grid-cols-3 @7xl:grid-cols-4',
};

type TerritoryGridContainerProps = {
  children: ReactNode;
  forceMobileView?: boolean;
  columns?: TColumnVariant;
};

export const TerritoryGridContainer: FC<TerritoryGridContainerProps> = ({ children, columns = 'four' }) => (
  <div className="@container">
    <div className={cx('grid grid-cols-1 gap-5', columnVariant[columns])}>{children}</div>
  </div>
);
